import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const WhatsAppButton = ({ settings }) => {
  const [isVisible, setIsVisible] = useState(false);
  const data = settings || companyInfo;
  const whatsappNumber = data.whatsapp?.replace(/\D/g, '') || '5491167667569';
  const message = encodeURIComponent('Hola, estoy interesado en conocer más sobre sus máquinas para cerámica.');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <div className={`fixed bottom-8 right-8 z-50 transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'}`}>
      <Button
        onClick={handleClick}
        className="bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 flex items-center justify-center group"
      >
        <MessageCircle className="w-8 h-8 group-hover:scale-110 transition-transform duration-200" />
      </Button>
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
        <div className="bg-stone-900 text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap shadow-lg">
          Chatea con nosotros
        </div>
      </div>
    </div>
  );
};

export default WhatsAppButton;
